// import logo from "./logo.svg";
import "./App.css";
import HomePage from "./pages/HomePage";
import { Routes, Route, useLocation } from "react-router-dom";
import FarmListPage from "./pages/farm-list/FarmListPage.jsx";
import Listing from "./pages/FarmListing.jsx";
import Footer from "./layouts/Footer";
import Header from "./layouts/Header";
import ListHeader from "./layouts/ListHeader";
// import WideHeader from "./layouts/WideHeader";
import "./assets/scripts/index.js";
import ScrollToTop from "./components/ScrollToTop";
import { MapViewProvider } from "./hooks/MapViewContext.js";
import { useEffect } from "react";

import FarmDetailPage from "./pages/farm-detail/FarmDetailPage.jsx";
import NotFoundPage from "./pages/NotFoundPage.jsx";
import SearchList from "./pages/search-list/SearchList.jsx";

function App() {
  const loc = useLocation();
  const path = loc.pathname;

  // Calculate and set scrollbar width globally to prevent layout shift
  useEffect(() => {
    const calculateScrollbarWidth = () => {
      // Create a temporary element to measure scrollbar width
      const outer = document.createElement('div');
      outer.style.visibility = 'hidden';
      outer.style.overflow = 'scroll';
      outer.style.msOverflowStyle = 'scrollbar';
      outer.style.width = '100px';
      outer.style.height = '100px';
      document.body.appendChild(outer);

      const inner = document.createElement('div');
      inner.style.width = '100%';
      inner.style.height = '100%';
      outer.appendChild(inner);

      const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
      document.body.removeChild(outer);

      // Set the calculated scrollbar width as a CSS custom property
      document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
      
      return scrollbarWidth;
    };

    // Calculate scrollbar width on app mount
    calculateScrollbarWidth();

    // Recalculate on window resize
    const handleResize = () => {
      calculateScrollbarWidth();
    };

    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isFarmPage = path.startsWith("/farm");
  const isCategoryPage = path.startsWith("/category");
  const isListingPage = path.startsWith("/listing");
  const isSearchPage = path.startsWith("/search");

  // Check if current path matches any of our defined routes
  // Include all valid static routes - both existing and planned routes from navigation
  const validRoutes = ["/", "/listing", "/farm/:farmId/:farmName", "/category/:categoryId", "/search"];
  
  // Handle dynamic routes with parameters
  const isDynamicRoute = 
    path.match(/^\/farm\/[^\/]+\/[^\/]+$/) || 
    path.match(/^\/category\/[^\/]+$/) ||
    path.match(/^\/search/);
    
  // A path is a 404 only if it doesn't match any valid static or dynamic route
  const is404Page = !validRoutes.includes(path) && !isDynamicRoute;

  return (
    <MapViewProvider>
      <div className="app">
        <ScrollToTop />

        {!is404Page && (
          <>
            {isFarmPage || isCategoryPage || isListingPage || isSearchPage ? (
              <ListHeader 
                categoryStyle={isCategoryPage} 
                searchStyle={isSearchPage}
                showMapToggle={!isSearchPage}
                hideMobileNav={isFarmPage}
              />
            ) : (
              <Header />
            )}
          </>
        )}

        <main
          className={`main-content ${
            isSearchPage 
              ? "search-list-main-content"
              : ( isFarmPage || isCategoryPage || isListingPage)
              ? "list-main-content"
              : ""
          } ${is404Page ? "no-header-footer" : ""}`}
        >
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/listing" element={<Listing />} />

            <Route path="/farm/:farmId/:farmName" element={<FarmDetailPage />} />
            {/* <Route path="/farm/:farmId" element={<FarmDetailPage />} /> */}
            <Route path="/category/:categoryId" element={<FarmListPage />} />
            <Route path="/search" element={<SearchList />} />

            {/* Catch-all route for 404 pages */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>

        {!is404Page && <Footer categoryStyle={isCategoryPage} />}
      </div>
    </MapViewProvider>
  );
}

export default App;
